// Static types data - supports ja/en language switching
import comprehensiveTypesJa from './comprehensive_types.json';
import comprehensiveTypesEn from './comprehensive_types_en.json';

const dataSources = {
  ja: comprehensiveTypesJa,
  en: comprehensiveTypesEn,
};

// Transform comprehensive_types.json to the format expected by the UI
const transformTypeData = (code, data, lang) => ({
  code,
  label: lang === 'en'
    ? `${data.name} (${data.archetype})`
    : `${data.name}（${data.archetype}）`,
  name: data.name,
  archetype: data.archetype,
  tagline: data.tagline || '',  // v2.0 新フィールド: 25-40字の詩的な一行
  summary: data.description,
  decision_style: data.decision_making_style,
  choice_pattern: data.choice_pattern,
  risk_note: data.blindspot,
  relation_hint: data.interpersonal_dynamics,
  growth_tip: data.growth_path,
  // v3.0 追加項目（占星術の座から導出した構造記述）
  axis_breakdown: data.axis_breakdown,
  astrological_seat: data.astrological_seat,
  work_style: data.work_style,
  under_pressure: data.under_pressure,
  environment: data.environment,
  common_misreading: data.common_misreading,
  design_gap_reading: data.design_gap_reading
});

// Get all types as an array (for list page)
export const getAllTypes = (lang = 'ja') => {
  const source = dataSources[lang] || dataSources.ja;
  return Object.entries(source).map(([code, data]) =>
    transformTypeData(code, data, lang)
  );
};

// Get single type by code
export const getTypeByCode = (code, lang = 'ja') => {
  const source = dataSources[lang] || dataSources.ja;
  const data = source[code];
  if (!data) return null;
  return transformTypeData(code, data, lang);
};

// Legacy exports for backward compatibility (Japanese)
export const allTypes = getAllTypes('ja');
export const typesByCode = Object.fromEntries(
  allTypes.map(t => [t.code, t])
);
export const rawTypesData = comprehensiveTypesJa;
